(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("@tableau/telemetry-api-contract"), require("@tableau/preslayer-api-contract"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery", "@tableau/telemetry-api-contract", "@tableau/preslayer-api-contract"], factory);
	else if(typeof exports === 'object')
		exports["JsApiPlatform"] = factory(require("jquery"), require("@tableau/telemetry-api-contract"), require("@tableau/preslayer-api-contract"));
	else
		root["JsApiPlatform"] = factory(root["$"], root["TelemetryAPIContract"], root["PresLayerAPIContract"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__6779__, __WEBPACK_EXTERNAL_MODULE__92939__, __WEBPACK_EXTERNAL_MODULE__18827__) {
return 